import { render } from "./CaseLaboratoryModal.vue?vue&type=template&id=742ff8d8&scoped=true&ts=true"
import script from "./CaseLaboratoryModal.vue?vue&type=script&lang=ts"
export * from "./CaseLaboratoryModal.vue?vue&type=script&lang=ts"

import "./CaseLaboratoryModal.vue?vue&type=style&index=0&id=742ff8d8&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742ff8d8"]])

export default __exports__